import React from 'react';
import { FormContext } from 'react-hook-form';
import { t, Trans } from '@lingui/macro';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationScrollView from '@src/components/AuthenticationScrollView';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
import Separator from '@src/components/Separator';
import TextInput from '@src/components/TextInput';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { i18n } from '@src/i18n';

import { Container, Title, Wrapper } from './styled';
import { Props } from './types';
import useForm from './useForm';

const Screen: React.FC<Props> = () => {
  const { form, handleSubmit, loading } = useForm();

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer>
        <AuthenticationScrollView>
          <Container>
            <FormContext {...form}>
              <Wrapper>
                <Title>
                  <Trans>Time to introduce yourself to us!</Trans>
                </Title>
                <TextInput
                  name="name"
                  autoCapitalize="none"
                  label={i18n._(t`Name`)}
                  disabled={loading}
                />
                <Separator />
              </Wrapper>
            </FormContext>
            <AuthenticationSendButton
              loading={loading}
              disabled={loading}
              onPress={handleSubmit}
            >
              <Trans>Enter</Trans>
            </AuthenticationSendButton>
          </Container>
        </AuthenticationScrollView>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'SetupUserInfo';

export default Screen;
